<div class="container">
  <div class="card card-login mx-auto mt-5">
    <div class="card-body">
      <h4 class="card-title">{{"reset-password.restore-password" | translate }}</h4>
      <form (submit)="resetPassword()" #resetForm="ngForm" [matchPassword]="['passwordControl','passwordConfirmationControl']" *ngIf="!reseted">
        <div *ngIf="!passwordMinLength || !passwordCapsLower || !passwordNumber || !passwordSpecial || passwordSequences || passwordRepetition || !passwordSpaces"  class="alert alert-info text-center p-1" role="alert">
          <ul *ngIf="password">
            <li class="text-danger" *ngIf="!passwordMinLength">
              <p>{{"reset-password.minimum8" | translate }}</p>
            </li>
            <li class="text-danger" *ngIf="!passwordCapsLower">
              <p class="p-0 m-0">{{"reset-password.upper-lower" | translate }}</p>
              <p class="small example">{{"reset-password.invalid1" | translate }}</p>
            </li>
            <li class="text-danger" *ngIf="!passwordNumber">
              <p class="p-0 m-0">{{"reset-password.include-number" | translate }}</p>
              <p class="small example">{{"reset-password.invalid2" | translate }}</p>
            </li>
            <li class="text-danger" *ngIf="!passwordSpecial">
              <p class="p-0 m-0">{{"reset-password.special-char" | translate }}</p>
              <p class="small example">{{"reset-password.invalid3" | translate }}</p>
            </li>
            <li class="text-danger" *ngIf="passwordSequences">
              <p class="p-0 m-0">{{"reset-password.no-sequence" | translate }}</p>
              <p class="small example">{{"reset-password.invalid4" | translate }}</p>
            </li>
            <li class="text-danger" *ngIf="passwordRepetition" >
              <p class="p-0 m-0" >{{"reset-password.no-more-three" | translate }}</p>
              <p class="small example">{{"reset-password.invalid5" | translate }}</p>
            </li>
            <li class="text-danger" *ngIf="!passwordSpaces" >
              <p class="p-0 m-0">{{"reset-password.no-spaces" | translate }}</p>
              <p class="small example">{{"reset-password.invalid6" | translate }}</p>
            </li>
          </ul>
          <ul *ngIf="!password">
            <li>
              <p>{{"reset-password.minimum8" | translate }}</p>
            </li>
            <li>
              <p class="p-0 m-0">{{"reset-password.upper-lower" | translate }}</p>
              <p class="small example">{{"reset-password.invalid1" | translate }}</p>
            </li>
            <li>
              <p class="p-0 m-0">{{"reset-password.include-number" | translate }}</p>
              <p class="small example">{{"reset-password.invalid2" | translate }}</p>
            </li>
            <li>
              <p class="p-0 m-0">{{"reset-password.special-char" | translate }}</p>
              <p class="small example">{{"reset-password.invalid3" | translate }}</p>
            </li>
            <li>
              <p class="p-0 m-0">{{"reset-password.no-sequence" | translate }}</p>
              <p class="small example">{{"reset-password.invalid4" | translate }}</p>
            </li>
            <li>
              <p class="p-0 m-0">{{"reset-password.no-more-three" | translate }}</p>
              <p class="small example">{{"reset-password.invalid5" | translate }}</p>
            </li>
            <li>
              <p class="p-0 m-0">{{"reset-password.no-spaces" | translate }}</p>
              <p class="small example">{{"reset-password.invalid6" | translate }}</p>
            </li>
          </ul>
        </div>
        <div class="form-group" [ngClass]="{'has-danger': passwordControl.invalid && (passwordControl.dirty || passwordControl.touched)}">
          <label class="label">{{"reset-password.new-password" | translate }}</label>
          <div class="input-group">
            <div class="input-group-append">

              <button [ngClass]="showPassword ? 'btn rounded-left btn-outline-success' : 'btn rounded-left btn-outline-primary'"
                type="button" (click)="togglePasswordVisibility('password')">

                <i *ngIf="showPassword; else eyeSlash" class="fas fa-eye"></i>
                <ng-template #eyeSlash>
                  <i class="fas fa-eye-slash"></i>
                </ng-template>
              </button>

            </div>
            <input [type]="showPassword ? 'text' : 'password'" class="form-control" #passwordControl="ngModel" name="passwordControl" [(ngModel)]="password" (ngModelChange)="passwordValidation()" required [minlength]="8">
          </div>
          <div class="text-right">
            <label style="font-size: small">{{ "shared.login.show-password" | translate }}</label>
            <input class="ml-2" type="checkbox" name="newNip" value="nip" [(ngModel)]="showPassword">
          </div>
          <ul *ngIf="passwordControl.invalid && (passwordControl.dirty || passwordControl.touched)">
            <li class="error text-danger" *ngIf="passwordControl?.errors?.required">{{"reset-password.required-field" | translate }}</li>
          </ul>
        </div>
        <div class="form-group" [ngClass]="{'has-danger': passwordConfirmationControl.invalid && (passwordConfirmationControl.dirty || passwordConfirmationControl.touched)}">
          <label class="label">{{"reset-password.confirmation" | translate }}</label>
          <div class="input-group">
            <div class="input-group-append">

              <button [ngClass]="showPasswordConfirm ? 'btn rounded-left btn-outline-success' : 'btn rounded-left btn-outline-primary'"
                type="button" (click)="togglePasswordVisibility('confirm')">

                <i *ngIf="showPasswordConfirm; else eyeSlash" class="fas fa-eye"></i>
                <ng-template #eyeSlash>
                  <i class="fas fa-eye-slash"></i>
                </ng-template>
              </button>

            </div>
            <input [type]="showPasswordConfirm ? 'text' : 'password'" class="form-control" name="passwordConfirmationControl" #passwordConfirmationControl="ngModel" [minlength]="8" required [(ngModel)]="passwordConfirmation" (paste)="false">
          </div>
          <div class="text-right">
            <label style="font-size: small">{{ "shared.login.show-password" | translate }}</label>
            <input class="ml-2" type="checkbox" name="newNip1" value="nip" [(ngModel)]="showPasswordConfirm">
          </div>
          <ul *ngIf="passwordConfirmationControl.invalid && (passwordConfirmationControl.dirty || passwordConfirmationControl.touched)">
            <li class="error text-danger" *ngIf="passwordConfirmationControl?.errors?.required">{{"reset-password.required-field" | translate }}</li>
            <li class="error text-danger" *ngIf="passwordConfirmationControl?.errors?.passwordMismatch">{{"reset-password.not-match" | translate }}</li>
          </ul>
        </div>
        <div class="form-group">
          <button class="btn btn-secondary submit-btn btn-block" type="submit" [disabled]="!resetForm.form.valid || !this.passwordSpaces || !this.passwordMinLength || this.passwordRepetition || this.passwordSequences || !this.passwordNumber || !this.passwordSpecial || !this.passwordCapsLower" *ngIf="!submitting">{{"reset-password.restore-password2" | translate }}</button>
          <button *ngIf="loadingService" class="btn btn-info" type="button" disabled>
            <i class="fas fa-circle-notch fa-spin"></i>
          </button>
          <div class="dot-opacity-loader" *ngIf="submitting">
            <span></span>
            <span></span>
            <span></span>
          </div>
        </div>
      </form>
        <div class="alert alert-danger text-center p-1" role="alert" *ngIf="messageError">
          <i class="fas fa-times fa-2x"></i>
          <p class="m-0">{{"reset-password.link-expired" | translate}}</p>
        </div>
        <div class="alert alert-info text-center p-1" role="alert" *ngIf="messageInformation">
          <i class="fas fa-exclamation fa-2x"></i>
          <p class="m-0">{{"reset-password.success-update" | translate}}</p>
        </div>
    </div>
  </div>
</div>
